import data from './../AllFilter/allFilter.json';

export const switches: Record<string, string> = {
  deskCount: "Coworking Space",
  privateOfficeCount: "Private Office",
  virtualOfficeCount: "Virtual Office",
  loungeCount: "Airport Lounge",
};

export const flattenedData: Record<string, string> = {};

for (const categoryKey in data) {
  // @ts-ignore
  const categoryData = data[categoryKey];

  for (const key in categoryData) {
    flattenedData[key] = categoryData[key];
  }
}